// experience.ts — ported from the design attachment's anim-premium.js (6657-7277) for the
// #experience section.
//
// This module's job is narrower than it looks. anim-premium.js's `init()` (7268-7273) calls
// `upgradeHero()`, `upgradeMultiConnection()` and `upgradeMultiInternet()` — already ported by
// earlier tasks — but its own two comments right there say:
//   // Keep the original production comparison: exact copy, sizing and draggable divider.
//   // Keep the original production Experience block and its compact two-column layout.
// `upgradeBeforeAfter()` and `upgradeExperience()` (7213-7276), both defined a few lines above,
// are never called. Verified two more ways: (1) grepping the whole attachment for `.np-premium`
// in trial-beta.css turns up 18 rules, and every one keys off `#hero`, `#multiconnection`,
// `#multi-internet` or `.np5-legacy` — none off `#experience`, so the section's own styling was
// never wired to the premium tier at all; (2) the one live-DOM effect `upgradeHero()` has on this
// section — the `premium-experience-p1-client` timeline at source 6789-6825, which crossfades
// `[data-exp-p1-frame]` — animates elements that `.np5-client-video-mode` (baked into this
// section's own static markup, never toggled by any script) hides with `display:none !important`
// unconditionally. Porting that crossfade would spend a clock subscription animating properties
// nobody can see; skipped.
//
// So the section's real content (the video, the four frames, the three feature blocks, the CTA)
// needs no runtime animation at all — it is exactly the static, no-JS markup in experience.tsx.
// This module's only real job is the page-state toggle the brief's cross-task contract calls out:
// anim-premium.js's `init()` (7269) unconditionally adds `np-premium` once the engine is ready,
// and 18 CSS rules for sections ported by earlier tasks (hero.tsx, multiconnection.tsx,
// multi-internet.tsx) key off `.trial-beta-page.np-premium` — none of those modules add the class
// themselves, so until this one mounts, that CSS never matches. Scoped via `root.closest(...)`
// rather than `document.querySelector`, per the "every selector scoped to root" rule; the two are
// equivalent here since `.trial-beta-page` is an ancestor of this section's root.
import type { SectionModule } from './use-section-animation';

const PAGE_ROOT_SELECTOR = '.trial-beta-page';
const PREMIUM_CLASS = 'np-premium';

export const experienceAnimation: SectionModule = ({ root }) => {
  // Permanent once set, same as engine.ts's own `np` — the source never removes it either.
  root.closest<HTMLElement>(PAGE_ROOT_SELECTOR)?.classList.add(PREMIUM_CLASS);

  return () => {};
};
